
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.25 7.22v-.47a.5.5 0 00-.5-.5V1h-1.5v5.25a.5.5 0 00-.5.5v.47a4 4 0 102.5 0zM6 14a3 3 0 01-1.24-5.72.49.49 0 00.49.47h1.5a.49.49 0 00.49-.47A3 3 0 016 14zm1-3a4 4 0 00.3 1.51 2 2 0 000-3A4 4 0 007 11zm5.25-3.78v-.47a.5.5 0 00-.5-.5V1h-1.5v5.25a.5.5 0 00-.5.5v1.5a.5.5 0 00.5.5h1.5a.49.49 0 00.49-.47A3 3 0 0111 14a3 3 0 01-.9-.15 5.42 5.42 0 01-.71.81A4.11 4.11 0 0011 15a4 4 0 001.25-7.78z"}})])
          )
        }
      }
    